/**
 * Desktop sticky filter sidebar (lg+). Wraps `FilterSidebarBody` in a
 * bordered/rounded container with its own scroll region so long filter lists
 * can scroll while the page header stays fixed.
 *
 * Extracted from `app/(main)/products/ProductsClient.tsx` lines 1460–1467.
 */

"use client";

import {
  FilterSidebarBody,
  type FilterSidebarBodyProps,
} from "./FilterSidebarBody";
import { CustomOrderPrompt } from "../CustomOrderPrompt";

export function FilterSidebar(props: FilterSidebarBodyProps) {
  return (
    <aside className="hidden shrink-0 lg:block lg:w-60 xl:w-64 2xl:w-72">
      <div className="sticky top-24 flex max-h-[calc(100vh-7rem)] flex-col rounded-lg border border-border bg-muted/30 p-4">
        <p className="label-overline mb-1 shrink-0 text-muted-foreground">
          Filters
        </p>
        <div className="filter-scroll-container min-h-0 flex-1 overflow-y-auto overflow-x-hidden overscroll-contain">
          <FilterSidebarBody {...props} />
        </div>
        {/* Pinned OUTSIDE the scroll region so it stays visible while the filter
            list scrolls — a persistent "can't find it? ask us" affordance. */}
        <CustomOrderPrompt variant="card" />
      </div>
    </aside>
  );
}
